APP.home = function () {
	const [getNews, setNews] = useNews()
	const apiNews = lang === 'en' ? '/en/wp-json/wp/v2/pages/11' : '/wp-json/wp/v2/pages/11'
	let strategyCount = 0
	let isOurStategy = true

	async function init() {
		const newsItems = await getData(`${apiURL}${apiNews}`)
		setNews(newsItems?.acf?.our_efforts?.efforts)
		//console.log(getNews())

		renderEffortsToDom(getNews())
		renderEffortsDetailToDom(getNews())

		$('.slick-our-sustainability').slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		})

		$('.slick-our-sustainability').on('swipe', function () {
			$('.slick-our-sustainability').addClass('is-disabled')
		})

		$('.slick-our-sustainability').on('beforeChange', function () {
			$('.slick-our-sustainability').addClass('is-disabled')
		})

		$('.slick-our-sustainability').on('afterChange', function () {
			setTimeout(() => {
				$('.slick-our-sustainability').removeClass('is-disabled')
			}, 100)
		})

		$('.modal-close').on('click', function (e) {
			e.preventDefault()
			gsap.to('.modal-dialog', {
				duration: 0.4,
				alpha: 0,
				y: 300,
				ease: 'power1.out',
				onComplete: function () {
					gsap.to('.modal-our-efforts', {
						duration: 0.4,
						alpha: 0,
						ease: 'power1.out',
						onComplete: function () {
							$('.modal-our-efforts').removeAttr('style')
							$('.modal-dialog').removeAttr('style')
						},
					})
				},
			})
		})

		$('.our-stategy-logo').on('click', function () {
			if (isOurStategy) {
				strategyCount = strategyCount + 1
				if (strategyCount >= 3) {
					strategyCount = 0
				}

				const _this = $(this)
				const pos = _this.data(`pos-${strategyCount}`)
				const itemShow = _this.data(`class-show-${strategyCount}`)
				const itemShowTextShow = $(itemShow).find('.our-stategy-show')
				const itemShowTextHide = $(itemShow).find('.our-stategy-hide')

				WIN_WIDTH = WINDOW.width()

				//$('.our-stategy-hover').removeClass(CLASS._active)
				_this.addClass(CLASS._active)

				isOurStategy = false
				$('.our-stategy-item').removeClass('is-active')

				gsap.to('.our-stategy-center', {
					duration: 0.4,
					alpha: 0,
				})

				gsap.to($('.our-stategy-center').eq(strategyCount), {
					duration: 0.4,
					alpha: 1,
					delay: 0.2,
				})

				gsap.to($('.our-stategy-cate-item').eq(strategyCount), {
					duration: 0.4,
					scale: 1.15,
					// x: -10,
					// y: -10,
					ease: 'back.out',
					onComplete: function () {
						gsap.to($('.our-stategy-cate-item').eq(strategyCount), {
							duration: 0.4,
							scale: 1,
							// x: 0,
							// y: 0,
							ease: 'back.out',
						})
					},
				})

				if (WIN_WIDTH > 992) {
					gsap.set(itemShowTextHide, {
						height: 0,
					})

					gsap.set(itemShowTextShow, {
						alpha: 0,
					})

					$('.our-stategy-item').each(function (index, item) {
						gsap.to(item, {
							duration: 0.3,
							//alpha: 0,
							x: pos[index],
							ease: 'power3.out',
							onComplete: function () {
								gsap.to('.our-stategy-hide', {
									duration: 0.3,
									height: 0,
									ease: 'power3.out',
									onComplete: function () {
										$(itemShow).addClass('is-active')
										gsap.to(itemShowTextHide, {
											duration: 0.3,
											height: 'auto',
											ease: 'power3.out',
											onComplete: function () {
												gsap.to(itemShowTextShow, {
													duration: 0.5,
													alpha: 1,
													onComplete: function () {
														isOurStategy = true
													},
												})
											},
										})
									},
								})
							},
						})
					})

					if (itemShow === '.our-stategy-item-environmental') {
						$('.our-stategy-logo')
							.removeClass('is-border-blue')
							.removeClass('is-border-orange')
							.addClass('is-border-green')
					} else if (itemShow === '.our-stategy-item-responsible') {
						$('.our-stategy-logo')
							.removeClass('is-border-green')
							.removeClass('is-border-orange')
							.addClass('is-border-blue')
					} else if (itemShow === '.our-stategy-item-social') {
						$('.our-stategy-logo')
							.removeClass('is-border-green')
							.removeClass('is-border-blue')
							.addClass('is-border-orange')
					}
				} else {
					$('.our-stategy-item').removeAttr('style')

					gsap.set('.our-stategy-item', {
						alpha: 0,
						y: 50,
						x: 0,
					})

					if (itemShow === '.our-stategy-item-environmental') {
						$('.our-stategy-item-social').insertBefore('.our-stategy-item-responsible')
						$('.our-stategy-item-environmental').insertBefore('.our-stategy-item-social')
						$('.our-stategy-logo')
							.removeClass('is-border-blue')
							.removeClass('is-border-orange')
							.addClass('is-border-green')
					} else if (itemShow === '.our-stategy-item-responsible') {
						$('.our-stategy-item-social').insertBefore('.our-stategy-item-environmental')
						$('.our-stategy-item-responsible').insertBefore('.our-stategy-item-social')
						$('.our-stategy-logo')
							.removeClass('is-border-green')
							.removeClass('is-border-orange')
							.addClass('is-border-blue')
					} else if (itemShow === '.our-stategy-item-social') {
						$('.our-stategy-item-environmental').insertBefore('.our-stategy-item-responsible')
						$('.our-stategy-item-social').insertBefore('.our-stategy-item-environmental')
						$('.our-stategy-logo')
							.removeClass('is-border-green')
							.removeClass('is-border-blue')
							.addClass('is-border-orange')
					}

					gsap.set(itemShowTextHide, {
						height: 0,
					})

					gsap.set(itemShowTextShow, {
						alpha: 0,
					})

					gsap.to('.our-stategy-hide', {
						duration: 0.3,
						height: 0,
						ease: 'power3.out',
						onComplete: function () {
							$(itemShow).addClass('is-active')
							gsap.to(itemShowTextHide, {
								duration: 0.3,
								height: 'auto',
								ease: 'power3.out',
								onComplete: function () {
									gsap.to(itemShowTextShow, {
										duration: 0.3,
										alpha: 1,
									})

									gsap.set($('.our-stategy-item').eq(1), {
										width: '90%',
									})

									gsap.set($('.our-stategy-item').eq(2), {
										width: '80%',
									})

									gsap.to('.our-stategy-item', {
										duration: 0.3,
										alpha: 1,
										y: 0,
										stagger: 0.15,
										ease: 'power3.out',
										onComplete: function () {
											isOurStategy = true
										},
									})
								},
							})
						},
					})
				}
			}
		})
	}

	function detectOurStategy() {
		WIN_WIDTH = WINDOW.width()

		const _this = $('.our-stategy-logo')
		const _thisW = _this.width()
		const pos = _this.data(`pos-${strategyCount}`)
		const itemShow = _this.data(`class-show-${strategyCount}`)

		if (WIN_WIDTH > 992) {
			$('.our-stategy-item').removeAttr('style')
			$('.our-stategy-item-social').insertBefore('.our-stategy-item-responsible')
			$('.our-stategy-item-environmental').insertBefore('.our-stategy-item-social')

			$('.our-stategy-item').each(function (index, item) {
				gsap.set(item, {
					x: pos[index],
				})
			})

			if (itemShow === '.our-stategy-item-environmental') {
				$('.our-stategy-logo')
					.removeClass('is-border-blue')
					.removeClass('is-border-orange')
					.addClass('is-border-green')
			} else if (itemShow === '.our-stategy-item-responsible') {
				$('.our-stategy-logo')
					.removeClass('is-border-green')
					.removeClass('is-border-orange')
					.addClass('is-border-blue')
			} else if (itemShow === '.our-stategy-item-social') {
				$('.our-stategy-logo')
					.removeClass('is-border-green')
					.removeClass('is-border-blue')
					.addClass('is-border-orange')
			}
		} else {
			$('.our-stategy-item').removeAttr('style')

			if (itemShow === '.our-stategy-item-environmental') {
				$('.our-stategy-item-social').insertBefore('.our-stategy-item-responsible')
				$('.our-stategy-item-environmental').insertBefore('.our-stategy-item-social')
				$('.our-stategy-logo')
					.removeClass('is-border-blue')
					.removeClass('is-border-orange')
					.addClass('is-border-green')
			} else if (itemShow === '.our-stategy-item-responsible') {
				$('.our-stategy-item-social').insertBefore('.our-stategy-item-environmental')
				$('.our-stategy-item-responsible').insertBefore('.our-stategy-item-social')
				$('.our-stategy-logo')
					.removeClass('is-border-green')
					.removeClass('is-border-orange')
					.addClass('is-border-blue')
			} else if (itemShow === '.our-stategy-item-social') {
				$('.our-stategy-item-environmental').insertBefore('.our-stategy-item-responsible')
				$('.our-stategy-item-social').insertBefore('.our-stategy-item-environmental')
				$('.our-stategy-logo')
					.removeClass('is-border-green')
					.removeClass('is-border-blue')
					.addClass('is-border-orange')
			}

			gsap.set($('.our-stategy-item').eq(1), {
				width: '90%',
			})

			gsap.set($('.our-stategy-item').eq(2), {
				width: '80%',
			})
		}

		gsap.set('.our-stategy-watter', {
			scale: (_thisW / 606).toFixed(2),
		})
	}

	function renderEffortsItem(item, index) {
		return `<div class="slick-slide" data-color="${item?.category}">
			<div class="card-our-efforts" data-index="${index}">
				<picture>
					<source media="(max-width:991px)" srcset="${
						lang === 'en' ? item?.thumbnail_image_mobile_en : item?.thumbnail_image_mobile
					}" />
					<source media="(min-width:992px)" srcset="${
						lang === 'en' ? item?.thumbnail_image_en : item?.thumbnail_image
					}" />
					<img src="${lang === 'en' ? item?.thumbnail_image_en : item?.thumbnail_image}" alt="" />
				</picture>
				<div class="card-our-efforts-body">
					<h3 class="card-our-efforts-title">${item?.title}</h3>
					<button class="slick-next">Next</button>
				</div>
			</div>
		</div>`
	}

	function renderEffortsToDom(newsItems) {
		const effortsItems = newsItems.map((item, index) => renderEffortsItem(item, index))
		$('.slick-our-efforts').html(effortsItems)

		$('.slick-our-efforts').slick({
			centerMode: true,
			centerPadding: '60px',
			slidesToShow: 1,
			arrows: false,
			// responsive: [
			// 	{
			// 		breakpoint: 992,
			// 		settings: {
			// 			centerMode: false,
			// 			slidesToShow: 1,
			// 		},
			// 	},
			// ],
		})
		document.addEventListener('mousedown', () => $('.slick-our-efforts').addClass('is-opacity'))

		document.addEventListener('touchstart', () => $('.slick-our-efforts').addClass('is-opacity'))

		$('.slick-our-efforts').on('swipe', function () {
			$('.slick-our-efforts').addClass('is-disabled')
		})

		$('.slick-our-efforts').on('beforeChange', function () {
			$('.slick-our-efforts').addClass('is-disabled')
		})

		$('.slick-our-efforts').on('afterChange', function () {
			$('.slick-our-efforts').removeClass('is-opacity')
			setTimeout(() => {
				$('.slick-our-efforts').removeClass('is-disabled')
			}, 100)
		})

		$('.card-our-efforts').on('click', function () {
			const _this = $(this)
			const parent = _this.parents('.slick-slide')
			const dataIndex = _this.data('index')
			const color = parent.data('color')
			$('.modal-our-efforts').removeClass('cam vang xanh').addClass(color)

			$('.slick-our-efforts').addClass('is-opacity')

			if (!$('.slick-our-efforts').hasClass('is-disabled')) {
				gsap.set('.modal-our-efforts', {
					display: 'block',
					alpha: 0,
				})

				gsap.set('.modal-dialog', {
					alpha: 0,
					y: 300,
				})

				$('.slick-news-detail').slick('slickGoTo', dataIndex)
				$('.slick-news-detail').slick('refresh')

				gsap.set(BODY, {
					paddingRight: APP.getScrollbarWidth(),
				})

				BODY.addClass(CLASS._noscroll)

				gsap.to('.modal-our-efforts', {
					duration: 0.4,
					alpha: 1,
					ease: 'power1.out',
					onComplete: function () {
						gsap.to('.modal-dialog', {
							duration: 0.4,
							alpha: 1,
							y: 0,
							ease: 'power1.out',
						})
					},
				})
			}
		})

		AOS.init({
			duration: 2000,
		})

		$('.our-stategy-watter').animateSprite({
			fps: 12,
			loop: true,
		})

		detectOurStategy()
		APP.resize(detectOurStategy)

		setTimeout(() => {
			const { hash } = location
			if (hash) {
				const hashPosY = $(hash).length > 0 ? $(hash).offset().top : 0
				const headerH = $('.header').outerHeight()
				console.log(headerH)

				APP.setScrollTopAnimation(window, hashPosY - headerH)
			}
		}, 1500)
	}

	function renderEffortsDetailItem(item) {
		return `<div class="slick-slide" data-color="${item?.category}">
			<div class="card-news-detail">
				<button class="btn-icon btn-icon-close ${item?.category}">Close</button>
				<button class="btn-icon btn-icon-next ${item?.category}">Next</button>
				<button class="btn-icon btn-icon-prev ${item?.category}">Prev</button>
				<picture>
					<source media="(max-width:991px)" srcset="${
						lang === 'en' ? item?.popup_image_mobile_en : item?.popup_image_mobile
					}" />
					<source media="(min-width:992px)" srcset="${
						lang === 'en' ? item?.popup_image_en : item?.popup_image
					}" />
					<img src="${lang === 'en' ? item?.popup_image_en : item?.popup_image}" alt="" />
				</picture>
			</div>
		</div>`
	}

	function renderEffortsDetailToDom(newsItems) {
		const effortsDetailItems = newsItems.map((item) => renderEffortsDetailItem(item))
		$('.slick-news-detail').html(effortsDetailItems)

		$('.slick-news-detail').slick({
			slidesToShow: 1,
			fade: true,
			arrows: false,
			adaptiveHeight: true,
		})

		$('.slick-news-detail').on('afterChange', function (event, slick, currentSlide, nextSlide) {
			const color = $(slick.$slides[currentSlide]).data('color')
			$('.modal-our-efforts').removeClass('cam vang xanh').addClass(color)
		})

		$('.btn-icon-next').on('click', function () {
			APP.setScrollTopAnimation('.modal-our-efforts', 0, function () {
				$('.slick-news-detail').slick('slickNext')
			})
		})

		$('.btn-icon-prev').on('click', function () {
			APP.setScrollTopAnimation('.modal-our-efforts', 0, function () {
				$('.slick-news-detail').slick('slickPrev')
			})
		})

		$('.btn-icon-close').on('click', function (e) {
			e.preventDefault()
			gsap.to('.modal-dialog', {
				duration: 0.4,
				alpha: 0,
				y: 300,
				ease: 'power1.out',
				onComplete: function () {
					gsap.to('.modal-our-efforts', {
						duration: 0.4,
						alpha: 0,
						ease: 'power1.out',
						onComplete: function () {
							BODY.removeClass(CLASS._noscroll).removeAttr('style')
							$('.modal-our-efforts').removeAttr('style')
							$('.modal-dialog').removeAttr('style')
						},
					})
				},
			})
		})
	}

	function useNews() {
		let _news = null

		function getNews() {
			return _news
		}

		function setNews(data) {
			_news = [...data]
		}

		return [getNews, setNews]
	}

	async function getData(url) {
		const response = await fetch(url, {
			headers: {
				'Content-Type': 'application/json',
			},
		})

		const res = await response.json()

		return res
	}

	init()
}
